import { MediaImage } from "@/shared/components/MediaImage";
import type { OrderItemPreview } from "../../types/orders";

function initialsOf(label: string): string {
    return label
        .trim()
        .split(/\s+/)
        .slice(0, 2)
        .map((w) => w[0]?.toUpperCase() ?? "")
        .join("");
}

/** Miniatura de um item do pedido — imagem ou iniciais como fallback. */
export function OrderItemThumb({ item }: { item: OrderItemPreview }) {
    if (item.imageUrl) {
        return (
            <figure
                title={item.label}
                className="flex size-14 shrink-0 items-center justify-center overflow-hidden rounded-xl border border-base-300/60 bg-base-200/40"
            >
                <MediaImage
                    source="products"
                    path={item.imageUrl}
                    alt={item.imageAlt ?? item.label}
                    width={56}
                    height={56}
                    className="object-contain"
                />
            </figure>
        );
    }
    return (
        <div
            title={item.label}
            aria-label={item.label}
            className="inline-flex size-14 shrink-0 items-center justify-center rounded-xl border border-base-300/60 bg-base-300/50"
        >
            <span aria-hidden="true" className="text-[0.8rem] font-black tracking-wide text-base-content/70">
                {initialsOf(item.label)}
            </span>
        </div>
    );
}

/** Badge "+N" para itens além dos exibidos. */
export function ExtraBadge({ count }: { count: number }) {
    return (
        <div
            aria-label={`Mais ${count} ${count === 1 ? "item" : "itens"}`}
            className="inline-flex size-14 shrink-0 items-center justify-center rounded-xl border border-dashed border-base-300 bg-base-100/70 text-[0.82rem] font-extrabold text-base-content/70"
        >
            +{count}
        </div>
    );
}
